__turbopack_context__.v({
  "advancedFilter": "advanced-sidebar-casino-module-sass-module__0mWIZa__advancedFilter" + " " + __turbopack_context__.i(402915)["sportsNavItem"],
  "casinoNav": "advanced-sidebar-casino-module-sass-module__0mWIZa__casinoNav" + " " + __turbopack_context__.i(286078)["sportsNav"],
});
